/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// NOTE: This file is auto-generated. Do not edit manually.
// Run 'pnpm locales:aggregate-extensions' to regenerate this file.

import bopisTranslations from '@/extensions/bopis/locales/en-US/translations.json';
import multishipTranslations from '@/extensions/multiship/locales/en-US/translations.json';
import storeLocatorTranslations from '@/extensions/store-locator/locales/en-US/translations.json';
import themeSwitcherTranslations from '@/extensions/theme-switcher/locales/en-US/translations.json';

// Namespace is based on the following convention: extPascalCase, and it's the pascal case of the folder name (e.g. store-locator -> extStoreLocator)
export default {
    extBopis: bopisTranslations,
    extMultiship: multishipTranslations,
    extStoreLocator: storeLocatorTranslations,
    extThemeSwitcher: themeSwitcherTranslations,
};
